import axiosInstance from "../../axios";

export const getPlacedOrders = () => {
  return axiosInstance.get("/orders/placed");
}

export const updateDeliveryDate = async ({ orderId, deliveryDate }) => {
  return axiosInstance.post(`/orders/${orderId}/update_delivery_date`, {
    delivery_date: deliveryDate
  });
};
